export default {
    SHOW_LOADING(state, val) {
        state.isLoading = val;
    },
    SET_LOADED(state, val) {
        state.isLoaded = val;
    },
    SET_TIMEOUT: (state, min) => {
        state.mariTimeout = min;
    },
    SET_TIME_FORMAT: (state, val) => {
        state.timeFormat = val;
    },
    SET_DEFAULT_RECIPIENTS: (state, val) => {
        state.defaultRecipients = val;
    },
    SET_NAV_COLLAPSED: (state, val) => {
        state.navCollapsed = val;
    },

    SET_UNSAVED_CHANGES: (state, val) => {
        state.unsavedChanges = val;
    },

    SET_UPDATE_DATA: (state, val) => {
        state.updateData = val;
    },

    SET_FORM_VALID(state, val) {
        state.isFormValid = val;
    },

    SET_TABLE_VALID(state, val) {
        state.isTableValid = val;
    },

    SET_COLOR_SCHEME_ID(state, id) {
        state.colorSchemeId = id;
    },

    SET_AA(state, val) {
        state.assignmentArea = val;
    },

    SET_LOCATIONS(state, val) {
        state.allLocations = val;
    },

    SET_SU_AA(state, val) {
        state.superUserAreas = val;
    },

    SET_CALL_TYPES(state, val) {
        state.callTypes = val;
    },

    SET_WIDGET_ID(state, val) {
        state.expandedWidgetId = val;
    },

    SET_WIDGET_SELECT(state, val) {
        state.expandedWidgetSelect = val;
    },

    SET_EXPANDED_WIDGET(state, val) {
        state.expandedWidget = val;
    },

    SET_SELECTED_REPORT_TYPE(state, val) {
        state.selectedReportType = val;
    },

    SET_STAFF(state, val) {
        state.staff = val;
    },

    SET_MARI_CURRENT_TIME(state, val) {
        state.mariCurrentTime = val;
    },

    SET_DUTY_SELECTOR_STATE(state, val) {
        state.dutySelector = val;
    },

    ADD_ONKEYDOWN_HANDLER(state, { handlerName, handler }) {
        state.onKeyDownHandlers.push({ handlerName, handler });
    },

    REMOVE_KEYBOARD_HANDLER(state, handlerName) {
        const handlers = state.onKeyDownHandlers;

        const index = handlers.findIndex(item => item.handlerName === handlerName);

        if (index > -1) {
            handlers.splice(index, 1);
        }

        state.onKeyDownHandlers = handlers;
    },

    SET_ASSIGNMENTS_CONF(state, assignmentsConf) {
        state.assignmentsConf = assignmentsConf;
    },

    SET_TARGET_TIME_SETTINGS(state, calls) {
        state.targetTimeCalls = calls;
    },

    SET_LOG_SETTINGS(state, settings) {
        state.logSettings = settings;
    },

    SET_DRAGGING(state, { dragging }) {
        state.dragging = dragging;
    },

    SET_DROP_ALLOWING(state, { dropAllowing }) {
        state.dropAllowing = dropAllowing;
    },
};
